import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'co0016',
    ecrans: ['00-2']
});
